import { useQuery } from "@tanstack/react-query";

import { getClubEvent } from "@/app/api/dynabuy-back/api-events";
import { EventEnum } from "@/TS/Enums/global_enums";

interface UseEventQueryParams {
  type?: EventEnum;
  clubSlug?: string;
  startDate?: string;
}

export const useEventQuery = ({
  type,
  clubSlug,
  startDate,
}: UseEventQueryParams) => {
  return useQuery({
    queryKey: ["clubEvent", type, clubSlug, startDate],
    queryFn: () => getClubEvent(type, clubSlug, startDate),
  });
};
